// extracted by mini-css-extract-plugin
module.exports = {"dividerSmall":"ResearchUI_dividerSmall__2WD8F"};